<div
  class="uni-menu__trigger"
  [matMenuTriggerFor]="menu"
>
  <ng-content select="[uniMenuTrigger]"></ng-content>
</div>
<mat-menu #menu="matMenu" class="uni-menu__container">
  <ng-content></ng-content>
</mat-menu>
